import React, { useEffect, useState } from 'react';
import { useDeviceType } from 'common-utilities';
import ContentLoader from 'react-content-loader';
import { useHistory } from 'react-router-dom';
import Footer from '../../components/footer';
import OutlinedButton from '../../components/outlineButton';
import PrimaryButton from '../../components/primaryButton';
import NProgress from 'nprogress';
import SheildIcon from '../../assets/svg/paytmSheild.svg';
import { SCREEN_NAME } from '../../constants';
import './style.scss';
import 'nprogress/nprogress.css';
import {
	DEVICES,
	getCurrentEnv,
	Pulse,
	NavigationHelpers,
	DeviceHelper,
	NetworkHelper,
	fetchPropertyConfig
} from 'common-utilities';
import { DEFAULT_IVR, EVENT_CATEGORY } from '../../constants';

const ENV = getCurrentEnv();
const screenName = SCREEN_NAME + '_home';
NProgress.configure({ showSpinner: false });
function Home({ state }) {
	const DEVICE = useDeviceType();
	const [userDetails, setUserDetails] = useState({});
	const [fraudIVR, setfraudIVR] = useState('');
	const history = useHistory();
	const [apiStatus, setApiStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const [logoutStatus, setLogoutStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const handleLogout = e => {
		setLogoutStatus(NetworkHelper.API_STATUS.INITIALIZED);
		NProgress.start({
			showSpinner: false
		});
		Pulse.push({
			event_action: 'logout_clicked',
			screenName,
			platform: DeviceHelper.identify(),
			event_category: EVENT_CATEGORY
		});
		NetworkHelper.post(`${ENV}/v2/logoutFromAllDevices`, {
			state_token: state.searchToken
		})
			.then(data => {
				if (data.status === 'SUCCESS') {
					sessionStorage && sessionStorage.setItem('API_RESULT', state.searchToken);
					NProgress.done();
					setLogoutStatus(NetworkHelper.API_STATUS.SUCCESS);
					history.push('/success');
				} else {
					throw data;
				}
			})
			.catch(err => {
				NProgress.done();
				setLogoutStatus(NetworkHelper.API_STATUS.FAILURE);
				history.push('/error');
			});
	};
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');
	const setConfigData = async () => {
		sessionStorage &&
			sessionStorage.setItem(
				'REDIRECT_PAYTM_DEEPLINK',
				await fetchPropertyConfig('redirectPaytmDeepLink')
			);
		setfraudIVR(await fetchPropertyConfig('fraud_detection_ivr_number'));
	};
	useEffect(() => {
		setApiStatus(NetworkHelper.API_STATUS.INITIALIZED);
		setConfigData();
		NetworkHelper.get(`${ENV}/user/token/info?stateCode=${state.searchToken}`)
			.then(data => {
				setUserDetails(data);
				setApiStatus(NetworkHelper.API_STATUS.SUCCESS);
				sessionStorage && sessionStorage.setItem('state', JSON.stringify(data));
				setTimeout(() => {
					Pulse.push({
						event_action: 'logout_screen_loaded',
						screenName,
						platform: DeviceHelper.identify(),
						source: data.communicationType || '',
						event_category: EVENT_CATEGORY
					});
				});
			})
			.catch(err => {
				setApiStatus(NetworkHelper.API_STATUS.FAILURE);
				history.push('/error');
			});
	}, []);
	return (
		<React.Fragment>
			<div className="homePageContainer">
				<div className="imageContainer">
					<img src={SheildIcon} alt="sheild-icon" />
				</div>
				<div className="heading">Logout from All Devices & Linked Apps</div>
				{apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="infoContainer">
						{(userDetails['name'] || '').length > 0 && (
							<div>
								<span>Name: </span>
								<span className="value">{userDetails['name']}</span>
							</div>
						)}
						{(userDetails['moblieNumber'] || '').length > 0 && (
							<div>
								<span>Mobile No.:</span>
								<span className="value">{userDetails['moblieNumber']}</span>
							</div>
						)}
					</div>
				) : apiStatus === NetworkHelper.API_STATUS.INITIALIZED ? (
					<ContentLoader animate={true} width={200} viewBox="0 0 200 32">
						<rect x="0" y="4" rx="2" ry="2" width="200" height="8" />
						<rect x="0" y="20" rx="2" ry="2" width="120" height="8" />
					</ContentLoader>
				) : null}
				<div className="text-container">
					If you have experienced an unauthorised activity in your paytm account, you can
					safeguard your account by logging out of all devices and wallet linked apps.
				</div>
				{apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="timeContainer">
						<span>Last login time:</span>
						<span className="value">{userDetails['lastLoggedInTime']}</span>
					</div>
				) : apiStatus === NetworkHelper.API_STATUS.INITIALIZED ? (
					<ContentLoader width={200} viewBox="0 0 200 28">
						<rect x="0" y="15" rx="2" ry="2" width="300" height="10" />
					</ContentLoader>
				) : null}
				{DEVICE === DEVICES.DESKTOP ? (
					<div className="buttonContainer">
						<PrimaryButton
							onClick={e =>
								apiStatus === NetworkHelper.API_STATUS.SUCCESS &&
								logoutStatus !== NetworkHelper.API_STATUS.INITIALIZED
									? handleLogout(e)
									: null
							}
							oauth-id="logout_btn"
						>
							Logout
						</PrimaryButton>
						<OutlinedButton
							onClick={() => {
								Pulse.push({
									event_action: 'cancel_clicked',
									screenName,
									platform: DeviceHelper.identify(),
									event_category: EVENT_CATEGORY
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="cancel_btn"
						>
							<div className="buttonText">Cancel</div>
						</OutlinedButton>
					</div>
				) : DEVICE === DEVICES.MOBILE ? (
					<div className="mobileButtonContainer">
						<button
							className="button primary"
							onClick={e =>
								apiStatus === NetworkHelper.API_STATUS.SUCCESS
									? handleLogout(e)
									: null
							}
							oauth-id="logout_btn"
						>
							Logout
						</button>
						<button
							onClick={() => {
								Pulse.push({
									event_action: 'cancel_clicked',
									screenName,
									platform: DeviceHelper.identify(),
									event_category: EVENT_CATEGORY
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							className="button secondary"
							oauth-id="cancel_btn"
						>
							Cancel
						</button>
					</div>
				) : null}
			</div>
			{DEVICE === DEVICES.DESKTOP ? <Footer /> : null}
		</React.Fragment>
	);
}
export default Home;
